import script from "./FAQMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQMsg.vue?vue&type=script&setup=true&lang=js"

import "./FAQMsg.vue?vue&type=style&index=0&id=2af4fc73&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af4fc73"]])

export default __exports__